import React from 'react'

import { Button } from '@/components/Button/Button'
import { Icon } from '@/components/Icon/Icon'
import { IconButton } from '@/components/IconButton/IconButton'
import { faUser } from '@fortawesome/pro-light-svg-icons/faUser'
import { Avatar } from '@mui/material'

import { ProfileDropdown } from './ProfileDropdown'
import { StyledPaper, StyledPopper } from './StyledNavDropdown'

export type ProfileProps = React.ComponentProps<typeof Button> & {
  authenticated?: boolean
  onNonLoggedInClick?: () => void
  profileUrl?: string | null
  username?: string
  children?: React.ReactNode
}

export const Profile: React.FC<ProfileProps> = ({ authenticated, ...props }) => {
  if (authenticated) {
    return <ProfileWithAuth {...props} />
  }

  return <ProfileNoAuth {...props} />
}


export const ProfileWithAuth: React.FC<ProfileProps> = ({ authenticated, children, profileUrl, username, onNonLoggedInClick, ...props }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const onMouseClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const open = Boolean(anchorEl)
  const id = open ? 'shopping-cart-popper' : undefined

  return (
    <>
      <IconButton
        size="large"
        onClick={onMouseClick}
        aria-label="User Profile Dropdown"
        {...props}
      >
        {<Avatar
          alt={username || 'profile image'}
          src={profileUrl ? profileUrl : ''}
        />}
        <StyledPopper
          id={id}
          open={open}
          anchorEl={anchorEl}
          slotProps={{
            paper: {
              sx: {
                backgroundColor: 'transparent',
                overflow: 'visible',
              },
            },
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          disableScrollLock
          elevation={0}
        >
          <StyledPaper elevation={0}>
            <ProfileDropdown />
          </StyledPaper>
        </StyledPopper>
      </IconButton >
    </>
  )
}


const ProfileNoAuth: React.FC<ProfileProps> = ({ authenticated, onNonLoggedInClick, profileUrl, ...props }) => (
  <IconButton aria-label="Click to Login" size="large" onClick={onNonLoggedInClick} {...props}>
    <Icon icon={faUser} sx={{ color: '#F5F2EE' }} />
  </IconButton>
)


export type ProfileDropdownProps = {
  //
}
